import { useQuery } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'

import { useUploadDocumentStore } from '@/pages/_app/stores/use-upload-document-store'

import { getUserQuery } from '@/lib/queries/business/v2/user/queries'

export const useUploadDocumentContent = () => {
  const navigate = useNavigate()

  const { data: userData } = useQuery(getUserQuery)

  const { setFiles } = useUploadDocumentStore()

  const handleSelectDocumentFiles = (files: File[]) => {
    setFiles(files)
    void navigate({ to: '/process-document/progress' })
  }

  return {
    isAdmin: userData?.isAdmin,
    isFreeTrialAvailable: userData?.isFreeTrialAvailable,
    hasSubscription: userData?.hasSubscription,
    handleSelectDocumentFiles,
  }
}
